import { render, staticRenderFns } from "./PatternMenu.vue?vue&type=template&id=c59293e2&scoped=true"
import script from "./PatternMenu.vue?vue&type=script&lang=js"
export * from "./PatternMenu.vue?vue&type=script&lang=js"
import style0 from "./PatternMenu.vue?vue&type=style&index=0&id=c59293e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59293e2",
  null
  
)

export default component.exports